import { sendRequest } from "@/lib/calendesk-js-library/api/api-client";

const api = {
  healthy() {
    return sendRequest("GET", "healthy/tenant");
  },

  healthyCentral() {
    return sendRequest("GET", "healthy/central");
  },

  configuration(elements = "all") {
    return sendRequest("GET", `settings/${elements}`);
  },

  adminConfiguration() {
    return sendRequest("GET", "admin/settings", null, true);
  },

  updateConfiguration(data) {
    return sendRequest("PATCH", "admin/settings", data, true);
  },

  generateRegulations(data) {
    return sendRequest("POST", "admin/regulations/generate", data, true);
  },

  stats() {
    return sendRequest("GET", "admin/stats", null, true);
  },

  statsV2Dashboard(data) {
    return sendRequest("GET", "admin/v2/stats/dashboard", data, true);
  },
  statsV2Revenue(data) {
    return sendRequest("GET", "admin/v2/stats/revenue", data, true);
  },
  statsV2Bookings(data) {
    return sendRequest("GET", "admin/v2/stats/bookings", data, true);
  },
  statsV2Employees(data) {
    return sendRequest("GET", "admin/v2/stats/employees", data, true);
  },
  statsV2Services(data) {
    return sendRequest("GET", "admin/v2/stats/services", data, true);
  },
  statsV2Customers(data) {
    return sendRequest("GET", "admin/v2/stats/customers", data, true);
  },
  statsV2Patterns(data) {
    return sendRequest("GET", "admin/v2/stats/patterns", data, true);
  },
  statsV2Payments(data) {
    return sendRequest("GET", "admin/v2/stats/payments", data, true);
  },
  statsV2Subscriptions(data) {
    return sendRequest("GET", "admin/v2/stats/subscriptions", data, true);
  },
  statsV2Locations(data) {
    return sendRequest("GET", "admin/v2/stats/locations", data, true);
  },
  statsV2Products(data) {
    return sendRequest("GET", "admin/v2/stats/products", data, true);
  },
  statsV2Forecast(data) {
    return sendRequest("GET", "admin/v2/stats/forecast", data, true);
  },

  usersData() {
    return sendRequest("GET", "admin/user", null, true);
  },

  booking(bookingId) {
    return sendRequest("GET", `admin/bookings/${bookingId}`, null, true);
  },

  unavailableBookingSlot(unavailableBookingSlotId) {
    return sendRequest(
      "GET",
      `admin/unavailable-booking-slots/${unavailableBookingSlotId}`,
      null,
      true,
    );
  },

  groupBooking(groupId) {
    return sendRequest("GET", `admin/bookings/group/${groupId}`, null, true);
  },

  updateGroupBooking(data, groupId) {
    return sendRequest("PATCH", `admin/bookings/group/${groupId}`, data, true);
  },

  bookings(data) {
    return sendRequest("GET", "admin/bookings/v2", data, true);
  },

  events(data) {
    return sendRequest("GET", "admin/events", data, true);
  },

  eventsBulkSummary(data) {
    return sendRequest("POST", "admin/events/bulk-summary", data, true);
  },

  // What accepting waiting bookings would send and touch: booking_ids, or the bulk filters.
  eventsAcceptancePreview(data) {
    return sendRequest("POST", "admin/events/acceptance-preview", data, true);
  },

  groupBookings(data) {
    return sendRequest("GET", "admin/bookings/group", data, true);
  },

  generateFileRecords(category, data) {
    let url = null;
    const type = data.type;

    if (category === "events") {
      url = "admin/events/generate/" + data.type;
    } else if (category === "unavailable_booking_slots") {
      url = "admin/unavailable-booking-slots/generate/" + data.type;
    } else if (category === "bookings") {
      url = "admin/bookings/generate/" + data.type;
    } else if (category === "newsletter") {
      url = "admin/newsletter/generate/" + data.type;
    } else if (category === "users") {
      url = "admin/users/generate/" + data.type;
    } else if (category === "employees") {
      url = "admin/employees/generate/" + data.type;
    }

    const isBlob = type === "xlsx" || type === "ods" || type === "xls";

    return sendRequest("POST", url, data, true, false, {}, false, isBlob);
  },

  createBooking(data) {
    return sendRequest("POST", "admin/bookings", data, true);
  },

  createBookingPaymentTransaction(data) {
    return sendRequest("POST", "admin/payments/bookings", data, true);
  },

  deleteBookingPaymentTransaction(bookingId) {
    return sendRequest(
      "DELETE",
      `admin/payments/bookings/${bookingId}`,
      null,
      true,
    );
  },

  updateBooking(data, id) {
    return sendRequest("PATCH", `admin/bookings/${id}`, data, true);
  },

  updateMultipleBookings(data) {
    return sendRequest("PATCH", "admin/bookings", data, true);
  },

  deleteMultipleBookings(data) {
    return sendRequest("DELETE", "admin/bookings", data, true);
  },

  deleteMultipleUnavailableSlotsBookings(data) {
    return sendRequest("DELETE", "admin/unavailable-booking-slots", data, true);
  },

  deleteBooking(id) {
    return sendRequest("DELETE", `admin/bookings/${id}`, null, true);
  },

  unavailableSlots(data) {
    return sendRequest("GET", "admin/unavailable-booking-slots", data, true);
  },

  categoriesAndServices(data) {
    return sendRequest("GET", "admin/v2/categories/services", data, true);
  },

  categories(data) {
    return sendRequest("GET", "admin/categories", data, true);
  },

  category(id) {
    return sendRequest("GET", `admin/categories/${id}`, null, true);
  },

  createCategory(data) {
    return sendRequest("POST", "admin/categories", data, true);
  },

  updateCategory(data, id) {
    return sendRequest("PATCH", `admin/categories/${id}`, data, true);
  },

  deleteCategory(id) {
    return sendRequest("DELETE", `admin/categories/${id}`, null, true);
  },
  service(id) {
    return sendRequest("GET", `admin/services/${id}`, null, true);
  },
  searchForServices(data) {
    return sendRequest("GET", `admin/v2/services/search`, data, true);
  },
  createService(data) {
    return sendRequest("POST", "admin/services", data, true);
  },
  services(data) {
    return sendRequest("GET", "admin/services", data, true);
  },
  servicesSearch(data) {
    return sendRequest("GET", "admin/v2/services/search", data, true);
  },
  updateService(data, id) {
    return sendRequest("PATCH", `admin/services/${id}`, data, true);
  },
  updateMultipleServices(data) {
    return sendRequest("PATCH", `admin/services`, data, true);
  },
  deleteService(id) {
    return sendRequest("DELETE", `admin/services/${id}`, null, true);
  },
  createServiceType(data) {
    return sendRequest("POST", `admin/services/${data.serviceId}`, data, true);
  },
  deleteServiceType({ serviceId, serviceTypeId }) {
    return sendRequest(
      "DELETE",
      `admin/services/${serviceId}/types/${serviceTypeId}`,
      null,
      true,
    );
  },

  updateServiceType(data) {
    return sendRequest(
      "PATCH",
      `admin/services/${data.serviceId}/types/${data.serviceTypeId}`,
      {
        price: data.price,
        name: data.name,
        duration: data.duration,
      },
      true,
    );
  },

  employees(data) {
    return sendRequest("GET", "admin/employees", data, true);
  },

  employee(id) {
    return sendRequest("GET", `admin/employees/${id}`, null, true);
  },

  createEmployee(data) {
    return sendRequest("POST", "admin/employees", data, true);
  },

  updateEmployee(data, id) {
    return sendRequest("PATCH", `admin/employees/${id}`, data, true);
  },

  updateOwnEmployee(data) {
    return sendRequest("PATCH", `admin/employee`, data, true);
  },

  deleteEmployee(id) {
    return sendRequest("DELETE", `admin/employees/${id}`, null, true);
  },

  updateMultipleEmployees(data) {
    return sendRequest("PATCH", "admin/employees", data, true);
  },

  deleteMultipleEmployees(data) {
    return sendRequest("DELETE", "admin/employees", data, true);
  },

  users(data) {
    return sendRequest("GET", "admin/v2/users", data, true);
  },

  usersSearch(data) {
    return sendRequest("GET", "admin/v2/users/search", data, true);
  },

  user(id) {
    return sendRequest("GET", `admin/users/${id}`, null, true);
  },

  createUser(data) {
    return sendRequest("POST", "admin/users", data, true);
  },

  updateUser(data, id) {
    return sendRequest("PATCH", `admin/users/${id}`, data, true);
  },

  updateOwnUser(data) {
    return sendRequest("PATCH", `admin/user`, data, true);
  },

  updateDescription(data, id) {
    return sendRequest("PUT", `admin/users/${id}/description`, data, true);
  },

  updateUserPreferences(data, id) {
    return sendRequest("PATCH", `admin/users/${id}/preferences`, data, true);
  },

  updateMyPreferences(data) {
    return sendRequest("PATCH", "admin/me/preferences", data, true);
  },

  updateMultipleUsers(data) {
    return sendRequest("PATCH", "admin/users", data, true);
  },

  addUsersToGroups(data) {
    return sendRequest("PATCH", "admin/users/groups", data, true);
  },

  removeUsersFromGroups(data) {
    return sendRequest("DELETE", "admin/users/groups", data, true);
  },

  deleteMultipleUsers(data) {
    return sendRequest("DELETE", "admin/users", data, true);
  },

  deleteUser(id) {
    return sendRequest("DELETE", `admin/users/${id}`, null, true);
  },

  mergeUsersPreview(data) {
    return sendRequest("POST", "admin/users/merge/preview", data, true);
  },

  mergeUsers(data) {
    return sendRequest("POST", "admin/users/merge", data, true);
  },

  tags(data) {
    return sendRequest("GET", "admin/tags", data, true);
  },

  createTag(data) {
    return sendRequest("POST", "admin/tags", data, true);
  },

  updateTag(data, id) {
    return sendRequest("PATCH", `admin/tags/${id}`, data, true);
  },

  deleteTag(id) {
    return sendRequest("DELETE", `admin/tags/${id}`, null, true);
  },

  groups(data) {
    return sendRequest("GET", "admin/groups", data, true);
  },

  createGroup(data) {
    return sendRequest("POST", "admin/groups", data, true);
  },

  updateGroup(data, id) {
    return sendRequest("PATCH", `admin/groups/${id}`, data, true);
  },

  deleteGroup(id) {
    return sendRequest("DELETE", `admin/groups/${id}`, null, true);
  },

  permissions(data) {
    return sendRequest("GET", "admin/permissions", data, true);
  },

  logs(data) {
    return sendRequest("GET", "admin/logs", data, true);
  },

  roles(data) {
    return sendRequest("GET", "admin/roles", data, true);
  },

  resources(data) {
    return sendRequest("GET", "admin/resources", data, true);
  },

  resource(id) {
    return sendRequest("GET", `admin/resources/${id}`, null, true);
  },

  createResource(data) {
    return sendRequest("POST", "admin/resources", data, true);
  },

  updateResource(data, id) {
    return sendRequest("PATCH", `admin/resources/${id}`, data, true);
  },

  deleteResource(id) {
    return sendRequest("DELETE", `admin/resources/${id}`, null, true);
  },

  createUnavailableBookingSpot(data) {
    return sendRequest("POST", "admin/unavailable-booking-slots", data, true);
  },

  updateUnavailableBookingSpot(data, id) {
    return sendRequest(
      "PATCH",
      `admin/unavailable-booking-slots/${id}`,
      data,
      true,
    );
  },

  deleteUnavailableBookingSpot(id) {
    return sendRequest(
      "DELETE",
      `admin/unavailable-booking-slots/${id}`,
      null,
      true,
    );
  },

  getLocale() {
    return sendRequest("GET", "locale");
  },

  verifyCode(data, headers) {
    return sendRequest("POST", "verify/code", data, false, headers);
  },

  verifyEmail(data, headers) {
    return sendRequest("POST", "verify/email", data, false, headers);
  },

  register(data, headers, emailToVerify) {
    return sendRequest(
      "POST",
      "tenants",
      data,
      false,
      headers,
      {},
      true,
      false,
      emailToVerify,
    );
  },

  login(data, captchaToken = null) {
    return sendRequest(
      "POST",
      "admin/auth/login",
      data,
      false,
      {},
      { skipAuthRefresh: true },
      true,
      false,
      null,
      captchaToken,
    );
  },

  logout() {
    return sendRequest(
      "POST",
      "auth/logout",
      null,
      true,
      {},
      { skipAuthRefresh: true },
    );
  },

  updateUsersData(data) {
    return sendRequest("PATCH", "user", data, true);
  },

  uploadAvatar(data) {
    return sendRequest("POST", "user/upload/avatar", data, true, {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/x-www-form-urlencoded",
    });
  },

  uploadAvatarAdmin(data, id) {
    return sendRequest("POST", `admin/users/${id}/upload/picture`, data, true, {
      "X-Requested-With": "XMLHttpRequest",
      "Content-Type": "application/x-www-form-urlencoded",
    });
  },

  forgottenPassword(email) {
    return sendRequest(
      "GET",
      `admin/auth/login/${email}/remind-password`,
      null,
      false,
    );
  },

  resetPassword(data, token) {
    return sendRequest(
      "PUT",
      `auth/login/reset-password/${token}`,
      data,
      false,
    );
  },

  resendActivateEmail(email) {
    return sendRequest("GET", `auth/signup/${email}/resend-activation-link/1`);
  },

  activateAccount(token) {
    return sendRequest("GET", `auth/signup/activate/${token}`);
  },

  confirmEmailChange(token) {
    return sendRequest("PUT", `auth/email-change/confirm/${token}`);
  },

  resendEmailChange() {
    return sendRequest("POST", "admin/user/email-change/resend", null, true);
  },

  cancelEmailChange() {
    return sendRequest("DELETE", "admin/user/email-change", null, true);
  },

  companyData({ taxCountryISOCode, taxNumber }) {
    return sendRequest(
      "GET",
      `admin/company/${taxCountryISOCode}/${taxNumber}`,
      null,
      true,
    );
  },

  getAssetsUser(data) {
    return sendRequest("GET", "admin/user-images", data, true);
  },

  uploadUserImage(data, cancelToken, onUploadProgress) {
    return sendRequest(
      "POST",
      "admin/user-images",
      data,
      true,
      {
        "X-Requested-With": "XMLHttpRequest",
        "Content-Type": "application/x-www-form-urlencoded",
      },
      { cancelToken, onUploadProgress },
    );
  },

  updateUserImage(id, data) {
    return sendRequest("PATCH", `admin/user-images/${id}`, data, true);
  },

  removeAssetUser(id) {
    return sendRequest("DELETE", `admin/user-images/${id}`, null, true);
  },

  getWebDrafts(data) {
    return sendRequest("GET", "admin/editor/web/drafts", data, true);
  },

  getWebDraft(id) {
    return sendRequest("GET", `admin/editor/web/drafts/${id}`, null, true);
  },

  updateWebDraft(id, data) {
    return sendRequest("PATCH", `admin/editor/web/drafts/${id}`, data, true);
  },

  removeWebDraft(id) {
    return sendRequest("DELETE", `admin/editor/web/drafts/${id}`, null, true);
  },

  getMobileTemplates() {
    return sendRequest("GET", "admin/editor/mobile/template", null, true);
  },

  getMobileDrafts(data) {
    return sendRequest("GET", "admin/editor/mobile/drafts", data, true);
  },

  createMobileDraft(data) {
    return sendRequest("POST", "admin/editor/mobile/drafts", data, true);
  },

  getMobileDraft(id) {
    return sendRequest("GET", `admin/editor/mobile/drafts/${id}`, null, true);
  },

  updateMobileDraft(id, data) {
    return sendRequest("PATCH", `admin/editor/mobile/drafts/${id}`, data, true);
  },

  publishMobileDraft(id) {
    return sendRequest(
      "POST",
      `admin/editor/mobile/drafts/${id}/apply`,
      null,
      true,
    );
  },

  disableMobileDraft(id) {
    return sendRequest(
      "POST",
      `admin/editor/mobile/drafts/${id}/disable`,
      null,
      true,
    );
  },

  removeMobileDraft(id) {
    return sendRequest(
      "DELETE",
      `admin/editor/mobile/drafts/${id}`,
      null,
      true,
    );
  },

  getDomains(data) {
    return sendRequest("GET", "admin/domains", data, true);
  },

  getAvailableDomains() {
    return sendRequest("GET", "admin/domains/available", null, true);
  },

  addDomain(data) {
    return sendRequest("POST", "admin/domains", data, true);
  },

  updateDomain(id, data) {
    return sendRequest("PATCH", `admin/domains/${id}`, data, true);
  },

  removeDomain(id) {
    return sendRequest("DELETE", `admin/domains/${id}`, null, true);
  },

  searchForTenant(data) {
    return sendRequest("GET", "tenants", data);
  },

  getPlaces(data) {
    return sendRequest("GET", "admin/places", data, true);
  },

  getPlaceDetails(id) {
    return sendRequest("GET", `admin/places/${id}`, null, true);
  },

  getCompanyWorkingHours() {
    return sendRequest("GET", "admin/company-working-hours", null, true);
  },

  updateCompanyWorkingHours(data) {
    return sendRequest("PATCH", "admin/company-working-hours", data, true);
  },

  getCurrentTenantPlan() {
    return sendRequest("GET", "admin/tenant-plans/current", null, true);
  },

  getNotificationsUsage() {
    return sendRequest(
      "GET",
      "admin/tenant-plans/notifications/usage",
      null,
      true,
    );
  },

  updatePlanTrial(data) {
    return sendRequest("PUT", "admin/tenant-plans/trial", data, true);
  },

  updateTenantPackagePreferences(data) {
    return sendRequest(
      "PATCH",
      "admin/tenant-packages/config/preferences",
      data,
      true,
    );
  },

  updateTenantPackageConfiguration(data) {
    return sendRequest("PATCH", "admin/tenant-packages/config", data, true);
  },

  getPlans() {
    return sendRequest("GET", "admin/plans", null, true);
  },

  getDefaultPaymentMethod() {
    return sendRequest("GET", "admin/payment-method/default", null, true);
  },

  deletePaymentMethods() {
    return sendRequest("DELETE", "admin/payment-method/all", null, true);
  },

  getDefaultPaymentMethodInvokeToken(data) {
    return sendRequest("GET", "admin/payment-method/invoke", data, true);
  },

  getTenantsInvoiceData() {
    return sendRequest("GET", "admin/tenants/invoice", null, true);
  },

  getInvoices(data) {
    return sendRequest("GET", "admin/invoices", data, true);
  },

  updateTenantsInvoiceData(data) {
    return sendRequest("PATCH", "admin/tenants/invoice", data, true);
  },

  setupDefaultPaymentMethod(data) {
    return sendRequest("POST", "admin/payment-method/setup", data, true);
  },

  verifyPromoCode(code, period) {
    return sendRequest(
      "GET",
      `admin/promo-code/verify/${code}/${period}`,
      null,
      true,
    );
  },

  subscribePlan(data) {
    return sendRequest("POST", "admin/subscribe", data, true);
  },

  previewSubscription(data) {
    return sendRequest("POST", "admin/subscribe/preview", data, true);
  },

  retryPastDueSubscriptionPayment(data) {
    return sendRequest(
      "POST",
      "admin/subscription/invoices/past-due/pay",
      data,
      true,
    );
  },

  getPastDueSubscriptionInvoice(data) {
    return sendRequest(
      "GET",
      "admin/subscription/invoices/past-due",
      data,
      true,
    );
  },

  cancelSubscription(data) {
    return sendRequest("POST", "admin/subscription/cancel", data, true);
  },

  downloadInvoice(invoiceId) {
    return sendRequest(
      "GET",
      `admin/invoices/fakturownia/pdf/${invoiceId}`,
      null,
      true,
      {},
      {},
      false,
      true,
    );
  },

  packagesPurchase(data) {
    return sendRequest("POST", "admin/packages/purchase", data, true);
  },

  sendEmailWithClientMobileApp(data) {
    return sendRequest("POST", "admin/editor/mobile/email/send", data, true);
  },

  sendSmsWithClientMobileApp(data) {
    return sendRequest("POST", "admin/editor/mobile/sms/send", data, true);
  },

  getStripeAccount(data) {
    return sendRequest("GET", "admin/stripe/connect/account", data, true);
  },

  createStripeAccount(data) {
    return sendRequest("POST", "admin/stripe/connect/account", data, true);
  },

  deleteStripeAccount() {
    return sendRequest("DELETE", "admin/stripe/connect/account", null, true);
  },

  getStripeConnectProducts(data) {
    return sendRequest("GET", "admin/stripe/connect/products", data, true);
  },

  createStripeConnectProduct(data) {
    return sendRequest("POST", "admin/stripe/connect/products", data, true);
  },

  createStripeConnectProductPrice(productId, data) {
    return sendRequest(
      "POST",
      `admin/stripe/connect/products/${productId}/prices`,
      data,
      true,
    );
  },

  getPaymentsBookings(data) {
    return sendRequest("GET", "admin/payments/bookings", data, true);
  },

  getTenantByEmail(email) {
    return sendRequest("GET", "tenants/email", email);
  },

  createSessionId() {
    return sendRequest("POST", "admin/quick-session", null, true);
  },

  createAuthTokenWithSessionId(sessionId) {
    return sendRequest("POST", "admin/quick-session/token", sessionId);
  },

  getWb2Draft(id) {
    return sendRequest(
      "GET",
      `admin/website/builder/v2/drafts/${id}`,
      null,
      true,
    );
  },

  updateWb2Draft(draftId, data) {
    return sendRequest(
      "PATCH",
      `admin/website/builder/v2/drafts/${draftId}`,
      data,
      true,
    );
  },

  publishWb2Draft(id) {
    return sendRequest(
      "POST",
      `admin/website/builder/v2/drafts/${id}/apply`,
      null,
      true,
    );
  },

  disableWb2Draft(id) {
    return sendRequest(
      "POST",
      `admin/website/builder/v2/drafts/${id}/disable`,
      null,
      true,
    );
  },

  setDraftDomainAsMain(id) {
    return sendRequest(
      "POST",
      `admin/website/builder/v2/drafts/${id}/main-domain`,
      null,
      true,
    );
  },

  createWb2DraftPage(draftId, data) {
    return sendRequest(
      "POST",
      `admin/website/builder/v2/drafts/${draftId}/pages`,
      data,
      true,
    );
  },

  updateWb2DraftSection(draftId, sectionId, data) {
    return sendRequest(
      "PATCH",
      `admin/website/builder/v2/drafts/${draftId}/sections/${sectionId}`,
      data,
      true,
    );
  },

  updateWb2DraftPage(draftId, pageId, data) {
    return sendRequest(
      "PATCH",
      `admin/website/builder/v2/drafts/${draftId}/pages/${pageId}`,
      data,
      true,
    );
  },

  removeWb2DraftPage(draftId, pageId) {
    return sendRequest(
      "DELETE",
      `admin/website/builder/v2/drafts/${draftId}/pages/${pageId}`,
      null,
      true,
    );
  },

  removeWb2DraftSection(draftId, sectionId) {
    return sendRequest(
      "DELETE",
      `admin/website/builder/v2/drafts/${draftId}/sections/${sectionId}`,
      null,
      true,
    );
  },

  createWb2DraftSection(draftId, data) {
    return sendRequest(
      "POST",
      `admin/website/builder/v2/drafts/${draftId}/sections`,
      data,
      true,
    );
  },

  updateWb2DraftSectionImage(draftId, sectionID, data) {
    return sendRequest(
      "PUT",
      `admin/website/builder/v2/drafts/${draftId}/sections/${sectionID}/images`,
      data,
      true,
    );
  },

  getNotificationTemplates() {
    return sendRequest("GET", "admin/notifications/templates", null, true);
  },

  getNotificationTemplateTypes() {
    return sendRequest(
      "GET",
      "admin/notifications/templates/types",
      null,
      true,
    );
  },

  createNotificationTemplate(data) {
    return sendRequest("POST", "admin/notifications/templates", data, true);
  },

  updateNotificationTemplate(templateId, data) {
    return sendRequest(
      "PATCH",
      `admin/notifications/templates/${templateId}`,
      data,
      true,
    );
  },

  deleteNotificationTemplate(templateId) {
    return sendRequest(
      "DELETE",
      `admin/notifications/templates/${templateId}`,
      null,
      true,
    );
  },

  removeWb2DraftSectionImage(draftId, sectionID, slug) {
    return sendRequest(
      "DELETE",
      `admin/website/builder/v2/drafts/${draftId}/sections/${sectionID}/images/${slug}`,
      null,
      true,
    );
  },

  createWb2Draft(data) {
    return sendRequest("POST", "admin/website/builder/v2/drafts", data, true);
  },

  removeWb2Draft(id) {
    return sendRequest(
      "DELETE",
      `admin/website/builder/v2/drafts/${id}`,
      null,
      true,
    );
  },

  searchForUnsplashPhotos(data) {
    return sendRequest("GET", "admin/photos/unsplash/search", data, true);
  },

  selectUnsplashPhoto(id) {
    return sendRequest(
      "GET",
      `admin/photos/unsplash/select?id=${id}`,
      null,
      true,
    );
  },

  getAllNewsletterRecords(data) {
    return sendRequest("GET", "admin/newsletter", data, true);
  },

  getSingleNewsletterById(id) {
    return sendRequest("GET", `admin/newsletter/${id}`, null, true);
  },

  createNewsletter(data) {
    return sendRequest("POST", "admin/newsletter", data, true);
  },

  updateNewsletter(id, data) {
    return sendRequest("PATCH", `admin/newsletter/${id}`, data, true);
  },

  deleteMultipleNewsletterRecords(data) {
    return sendRequest("DELETE", "admin/newsletter", data, true);
  },

  getCustomerNotifications(data) {
    return sendRequest("GET", "admin/customer-notifications", data, true);
  },

  getCustomerNotification(notificationId) {
    return sendRequest(
      "GET",
      "admin/customer-notifications/" + notificationId,
      null,
      true,
    );
  },

  createCustomerNotification(data) {
    return sendRequest("POST", "admin/customer-notifications", data, true);
  },

  createGoogleCalendarAuthUrl(data) {
    return sendRequest("POST", "admin/google/calendar/auth-url", data, true);
  },

  createOutlookCalendarAuthUrl(data) {
    return sendRequest("POST", "admin/microsoft/outlook/auth-url", data, true);
  },

  createZoomAuthUrl(data) {
    return sendRequest("POST", "admin/zoom/auth-url", data, true);
  },

  enableGoogleCalendarForEmployee(data) {
    return sendRequest(
      "POST",
      "admin/google/calendar/employees/enable",
      data,
      true,
    );
  },

  enableOutlookCalendarForEmployee(data) {
    return sendRequest(
      "POST",
      "admin/microsoft/outlook/employees/enable",
      data,
      true,
    );
  },

  getListOfGoogleCalendars() {
    return sendRequest(
      "GET",
      "admin/google/calendar/employees/list",
      null,
      true,
    );
  },

  getListOfOutlookCalendars() {
    return sendRequest(
      "GET",
      "admin/microsoft/outlook/employees/list",
      null,
      true,
    );
  },

  pushEventsToGoogleCalendars() {
    return sendRequest(
      "POST",
      "admin/google/calendar/employees/push-events",
      null,
      true,
    );
  },

  pushEventsToOutlookCalendars() {
    return sendRequest(
      "POST",
      "admin/microsoft/outlook/employees/push-events",
      null,
      true,
    );
  },

  updateWatchedEmployeeGoogleCalendars(data) {
    return sendRequest(
      "PUT",
      "admin/google/calendar/employees/watched",
      data,
      true,
    );
  },

  updateWatchedEmployeeOutlookCalendars(data) {
    return sendRequest(
      "PUT",
      "admin/microsoft/outlook/employees/watched",
      data,
      true,
    );
  },

  getWatchedEmployeeGoogleCalendars() {
    return sendRequest(
      "GET",
      "admin/google/calendar/employees/watched/list",
      null,
      true,
    );
  },

  getWatchedEmployeeOutlookCalendars() {
    return sendRequest(
      "GET",
      "admin/microsoft/outlook/employees/watched/list",
      null,
      true,
    );
  },

  enableZoomForEmployee(data) {
    return sendRequest("POST", "admin/zoom/employees/enable", data, true);
  },

  disableGoogleCalendarForEmployee(data) {
    return sendRequest(
      "POST",
      "admin/google/calendar/employees/disable",
      data,
      true,
    );
  },

  disableOutlookCalendarForEmployee(data) {
    return sendRequest(
      "POST",
      "admin/microsoft/outlook/employees/disable",
      data,
      true,
    );
  },

  disableZoomorEmployee(data) {
    return sendRequest("POST", "admin/zoom/employees/disable", data, true);
  },

  getAllSubscriptions(data) {
    return sendRequest("GET", "admin/subscriptions", data, true);
  },

  getSubscription(id) {
    return sendRequest("GET", "admin/subscriptions/" + id, null, true);
  },

  getAllUserSubscriptions(data) {
    return sendRequest("GET", "admin/v2/users/subscriptions", data, true);
  },

  subscriptionsSearch(data) {
    return sendRequest("GET", "admin/subscriptions/search", data, true);
  },

  createUserSubscription(data) {
    return sendRequest("POST", `admin/users/subscriptions/`, data, true);
  },

  cancelUserSubscription(data) {
    return sendRequest(
      "POST",
      `admin/users/subscriptions/${data.id}/cancel`,
      data,
      true,
    );
  },

  deleteUserSubscription(subscriptionId) {
    return sendRequest(
      "DELETE",
      `admin/users/subscriptions/${subscriptionId}`,
      null,
      true,
    );
  },

  getAllUserSubscriptionPaymentTransactions(data) {
    return sendRequest(
      "GET",
      "admin/users/subscriptions/transactions",
      data,
      true,
    );
  },

  createUserSubscriptionPaymentTransaction(data) {
    return sendRequest(
      "POST",
      `admin/users/subscriptions/` +
        data.user_subscription_id +
        `/transactions`,
      data,
      true,
    );
  },

  deleteUserSubscriptionPaymentTransaction(
    userSubscriptionId,
    userSubscriptionPaymentTransactionId,
  ) {
    return sendRequest(
      "DELETE",
      `admin/users/subscriptions/` +
        userSubscriptionId +
        `/transactions/` +
        userSubscriptionPaymentTransactionId,
      null,
      true,
    );
  },

  createSubscription(data) {
    return sendRequest("POST", "admin/subscriptions", data, true);
  },

  updateSubscription(subscriptionId, data) {
    return sendRequest(
      "PUT",
      `admin/subscriptions/${subscriptionId}`,
      data,
      true,
    );
  },

  deleteSubscription(subscriptionId) {
    return sendRequest(
      "DELETE",
      `admin/subscriptions/${subscriptionId}`,
      null,
      true,
    );
  },

  getAllSimpleStoreProducts(data) {
    return sendRequest("GET", "admin/simple-store/product", data, true);
  },

  getAllSimpleStoreProductTransactions(data) {
    return sendRequest(
      "GET",
      "admin/simple-store/product/transaction",
      data,
      true,
    );
  },

  createSimpleStoreProduct(data) {
    return sendRequest("POST", "admin/simple-store/product", data, true);
  },

  createSimpleStoreProductPaymentTransaction(data) {
    return sendRequest(
      "POST",
      "admin/simple-store/product/transaction",
      data,
      true,
    );
  },

  deleteSimpleStoreProductPaymentTransaction(transactionId) {
    return sendRequest(
      "DELETE",
      `admin/simple-store/product/transaction/${transactionId}`,
      null,
      true,
    );
  },

  deleteSimpleStoreProduct(productId) {
    return sendRequest(
      "DELETE",
      `admin/simple-store/product/${productId}`,
      null,
      true,
    );
  },

  updateSimpleStoreProduct(productId, data) {
    return sendRequest(
      "PUT",
      `admin/simple-store/product/${productId}`,
      data,
      true,
    );
  },

  validateFakturowniaSettings(data) {
    return sendRequest("POST", "admin/fakturownia/validate", data, true);
  },

  fetchFakturowniaDepartments(data) {
    return sendRequest("POST", "admin/fakturownia/departments", data, true);
  },

  retryFakturowniaInvoice(data) {
    return sendRequest("POST", "admin/fakturownia/invoices/retry", data, true);
  },

  getApiKey(data) {
    return sendRequest("GET", "admin/api/key", data, true);
  },

  createApiKey(data) {
    return sendRequest("POST", "admin/api/key", data, true);
  },

  deleteApiKey(data) {
    return sendRequest("DELETE", "admin/api/key", data, true);
  },

  getAvailabilitySchedules(data) {
    return sendRequest("GET", "admin/availability-schedules", data, true);
  },

  createAvailabilitySchedule(data) {
    return sendRequest("POST", "admin/availability-schedules", data, true);
  },

  updateAvailabilitySchedule(id, data) {
    return sendRequest("PUT", `admin/availability-schedules/${id}`, data, true);
  },

  deleteAvailabilitySchedule(id) {
    return sendRequest(
      "DELETE",
      `admin/availability-schedules/${id}`,
      null,
      true,
    );
  },

  setAvailabilityScheduleAssignment(id, data) {
    return sendRequest(
      "PUT",
      `admin/availability-schedules/${id}/assignment`,
      data,
      true,
    );
  },

  setAvailabilityScheduleEmployeeAssignment(id, employeeId, data) {
    return sendRequest(
      "PUT",
      `admin/availability-schedules/${id}/assignment/employees/${employeeId}`,
      data,
      true,
    );
  },

  updateAvailabilitySchedulePeriod(id, data) {
    return sendRequest(
      "PATCH",
      `admin/availability-schedules/${id}/period`,
      data,
      true,
    );
  },

  getAvailableBookingSlots(data, sendWithAuth = false) {
    return sendRequest("GET", "available-slots", data, sendWithAuth);
  },

  getLocations(data) {
    return sendRequest("GET", "admin/location", data, true);
  },
  createLocation(data) {
    return sendRequest("POST", "admin/location", data, true);
  },
  updateLocation(data, locationId) {
    return sendRequest("PATCH", `admin/location/${locationId}`, data, true);
  },
  deleteLocation(locationId) {
    return sendRequest("DELETE", `admin/location/${locationId}`, null, true);
  },

  getBookingReminders(data) {
    return sendRequest("GET", "admin/bookings/reminders", data, true);
  },
  createBookingReminder(data) {
    return sendRequest("POST", "admin/bookings/reminders", data, true);
  },
  updateBookingReminder(reminderId, data) {
    return sendRequest(
      "PATCH",
      `admin/bookings/reminders/${reminderId}`,
      data,
      true,
    );
  },
  deleteBookingReminder(reminderId) {
    return sendRequest(
      "DELETE",
      `admin/bookings/reminders/${reminderId}`,
      null,
      true,
    );
  },
  checkEventsOverlaps(data) {
    return sendRequest("POST", "admin/events/check-overlaps", data, true);
  },

  // 2FA methods
  login2fa(data) {
    return sendRequest(
      "POST",
      "auth/2fa/login",
      data,
      false,
      {},
      { skipAuthRefresh: true },
    );
  },

  setup2FA(data) {
    return sendRequest("POST", "user/2fa/setup", data, true);
  },
  activate2FA(data) {
    return sendRequest("POST", "user/2fa/activate", data, true);
  },
  deactivate2FA(data) {
    return sendRequest("POST", "user/2fa/deactivate", data, true);
  },

  getWebhooks(data) {
    return sendRequest("GET", "admin/webhooks", data, true);
  },

  createWebhook(data) {
    return sendRequest("POST", "admin/webhooks", data, true);
  },

  deleteWebhook(webhookId) {
    return sendRequest("DELETE", `admin/webhooks/${webhookId}`, null, true);
  },

  updateWebhook(webhookId, data) {
    return sendRequest("PUT", `admin/webhooks/${webhookId}`, data, true);
  },

  integrateChatwoot(data) {
    return sendRequest("POST", "admin/chatwoot/integrate", data, true);
  },

  reactivateChatwoot() {
    return sendRequest("POST", "admin/chatwoot/reactivate", null, true);
  },

  disconnectChatwoot(data) {
    return sendRequest("POST", "admin/chatwoot/disconnect", data, true);
  },

  getChatwootSsoLink() {
    return sendRequest("GET", "admin/chatwoot/sso", null, true);
  },

  getChatwootAgents() {
    return sendRequest("GET", "admin/chatwoot/agents", null, true);
  },

  removeChatwootAgent(userId) {
    return sendRequest("DELETE", `admin/chatwoot/agents/${userId}`, null, true);
  },

  createBulkOperation(data) {
    return sendRequest("POST", "admin/bulk-operations", data, true);
  },

  getBulkOperations(data) {
    return sendRequest("GET", "admin/bulk-operations", data, true);
  },

  getBulkOperation(id) {
    return sendRequest("GET", `admin/bulk-operations/${id}`, null, true);
  },

  // Affiliate Program
  getAffiliateProgram() {
    return sendRequest("GET", "admin/affiliate", null, true);
  },

  joinAffiliateProgram(data) {
    return sendRequest("POST", "admin/affiliate/join", data, true);
  },

  getAffiliateReferrals(data) {
    return sendRequest("GET", "admin/affiliate/referrals", data, true);
  },

  getAffiliatePayouts(data) {
    return sendRequest("GET", "admin/affiliate/payouts", data, true);
  },

  requestAffiliatePayout(data) {
    return sendRequest("POST", "admin/affiliate/payouts", data, true);
  },

  leaveAffiliateProgram() {
    return sendRequest("DELETE", "admin/affiliate", null, true);
  },

  getAffiliateWelcomeBonus() {
    return sendRequest("GET", "admin/affiliate/welcome-bonus", null, true);
  },

  // News (Calendesk announcements shown in the panel bell)
  getAdminNews() {
    return sendRequest("GET", "admin/news", null, true);
  },

  markAdminNewsRead(id) {
    return sendRequest("POST", `admin/news/${id}/read`, null, true);
  },

  markAllAdminNewsRead() {
    return sendRequest("POST", "admin/news/read-all", null, true);
  },

  deleteAdminNewsForMe(id) {
    return sendRequest("DELETE", `admin/news/${id}`, null, true);
  },

  guestDataPurges(data) {
    return sendRequest("GET", "admin/guest-data/purges", data, true);
  },

  guestDataPurgesCsv() {
    return sendRequest("GET", "admin/guest-data/purges/csv", null, true);
  },

  guestDataPurgePreview(data) {
    return sendRequest("GET", "admin/guest-data/preview", data, true);
  },

  accountHistoryPreview() {
    return sendRequest(
      "GET",
      "admin/guest-data/account-history/preview",
      null,
      true,
    );
  },
};

export default api;
